var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"base-demo-print-area"},[_c('div',{staticClass:"ex1"},[_c('h2',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(_vm.department.name)+" ")])]),_c('div',{staticClass:"has-text-left is-size-10"},[_c('p',[_vm._v(" mjesec: "),_c('span',[_vm._v(" "+_vm._s(_vm.monthName)+" ")])])]),_c('div',{staticClass:"base-demo"},[_c('vue-table-dynamic',{attrs:{"params":_vm.params},on:{"cell-click":_vm.tableCellClicked,"on-row-dblclick":_vm.onRowDoubleClick,"row-click":_vm.onRowClicked,"cell-contextmenu":_vm.cm},scopedSlots:_vm._u([{key:"column-1",fn:function(ref){
var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
            })},[_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-2",fn:function(ref){
            var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-3",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-4",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-5",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-6",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-7",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-8",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-9",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-10",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-11",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-12",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-13",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-14",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-15",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-16",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-17",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-18",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-19",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-20",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-21",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-22",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-23",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-24",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-25",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-26",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-27",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-28",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-29",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-30",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-31",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-32",fn:function(ref){
              var props = ref.props;
return [_c('span',{staticClass:"cell--slot-1",style:({
              color: props.cellData.color,
              background: props.cellData.backgroundColor,
              position: 'relative',
            }),attrs:{"title":props.cellData.title}},[(props.cellData.borderLeftColor)?_c('span',{staticClass:"cell-inconsistency-triangle",style:({
                borderTopColor: props.cellData.borderLeftColor,
              })}):_vm._e(),_vm._v(_vm._s(props.cellData.value))])]}}])})],1),_c('context-menu',{ref:"menu",attrs:{"display":_vm.showContextMenu}},[_c('ul',[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCommentCMVisible),expression:"isCommentCMVisible"}],on:{"click":_vm.cmCommentClicked}},[_c('p',{staticClass:"cmitem"},[_vm._v("Komentar")])]),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLateCMVisible),expression:"isLateCMVisible"}],on:{"click":_vm.cmLateClicked}},[_c('p',{staticClass:"cmitem",staticStyle:{"background-color":"yellow"}},[_vm._v(" Status kašnjenja ")])]),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCommentCMVisible),expression:"isCommentCMVisible"}],on:{"click":_vm.cmViewDetails}},[_c('p',{staticClass:"cmitem",staticStyle:{"background-color":"lightGreen"}},[_vm._v(" Vidi detalje... ")])])])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"columns is-mobile"},[_vm._m(0)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-1 is-offset-half"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"has-text-centered"},[_c('p',[_vm._v("loading...")])])])])}]

export { render, staticRenderFns }